// Source chip (rule 2 made visible): what a value rests on. An unresolved source offers "Create client request".
import type { Source } from "../data/types";

const KIND_LABEL: Record<string, string> = { engagement: "Doc", store: "Record", computed: "Computed", "auditor-judgment": "Judgment", standard: "Standard", portal: "Client", prelim: "Prelim", unknown: "Source" };

export function SourceChip({ source, onRequest }: { source: Source; onRequest?: (s: Source) => void }) {
  const text = source.label ?? source.ref;
  if (!source.resolved) {
    return (
      <span className="inline-flex items-center gap-1 rounded border border-dashed border-blocked-line bg-blocked-bg px-1.5 py-0.5 text-[11px] text-blocked" title={source.ref}>
        <span aria-hidden="true">?</span><span>Unresolved: {text}</span>
        {onRequest && <button type="button" className="ml-1 underline" onClick={() => onRequest(source)}>Create client request</button>}
      </span>
    );
  }
  const body = (
    <>
      <span className="font-semibold">{KIND_LABEL[source.kind] ?? "Source"}</span>
      <span className="max-w-[22ch] truncate font-mono">{text}</span>
    </>
  );
  const cls = "inline-flex items-center gap-1 rounded border border-line bg-sunken px-1.5 py-0.5 text-[11px] text-ink hover:border-brand";
  return source.href
    ? <a href={source.href} className={cls} title={source.ref}>{body}</a>
    : <span className={cls} title={source.ref}>{body}</span>;
}

export function SourceList({ sources, onRequest }: { sources: Source[]; onRequest?: (s: Source) => void }) {
  if (!sources.length) return <span className="text-[11px] text-blocked">No source — this value cannot be used</span>;
  return <span className="inline-flex flex-wrap gap-1">{sources.map((s, i) => <SourceChip key={i} source={s} onRequest={onRequest} />)}</span>;
}
